import { RemoteDataSource, Settings } from "@/datasources/remote_datasource";
import { Failure } from "@/usecases/repository";
import { AppConfig } from "@/datasources/AppConfig";
import { reportarProblemaSchema } from "@/lib/validation";

export interface ReportarProblemaRequest {
  problema: string;
  indentificacaoTela: string;
}

export interface ReportarProblemaResponse {
  id: string;
  status: string;
  mensagem: string;
  dataCriacao: string;
}

class ReportarProblemaService {
  private readonly remoteDataSource: RemoteDataSource;

  constructor() {
    this.remoteDataSource = new RemoteDataSource(Settings.urlBase);
  }

  async reportarProblema(request: ReportarProblemaRequest): Promise<{ success: ReportarProblemaResponse } | { failure: Failure }> {
    const validation = reportarProblemaSchema.safeParse(request);
    if (!validation.success) {
      return {
        failure: new Failure({
          messages: validation.error.issues.map((issue) => issue.message),
        }),
      };
    }

    const response = await this.remoteDataSource.post<unknown>({
      endpoint: '/v1/notificacoes/reportar-problema',
      body: validation.data as unknown as Record<string, unknown>,
      headers: {
        'Accept': 'application/vnd.data.full.v1+json',
      },
      requiredToken: true,
    });

    if ('failure' in response) {
      return response;
    }

    return { success: response.success.body as ReportarProblemaResponse };
  }

  private generateId(): string {
    return `temp_${Date.now()}_${Math.random().toString(36).substr(2, 9)}`;
  }

  // Método utilitário para obter identificação da tela atual
  static getScreenIdentification(path: string): string {
    return AppConfig.getScreenId(path);
  }
}

// Exporta uma instância singleton do serviço
export const reportarProblemaService = new ReportarProblemaService();
